import "core-js/modules/es7.array.includes";
/**
   * [setStorageItem 设置缓存数据，可以设置isExpired表示设置记录时间]
   * @param {Storage} storage [localStorage/sessionStorage]
   * @param {string} key
   * @param {*} value
   * @param {boolean} isExpired [是否需要设置记录时间，若需要限制有效期内，设置true]
   */
function setStorageItem(storage, key, value, isExpired) {
  var expiredKey = key + "__expired__";
  storage.setItem(key, JSON.stringify(value));
  storage.removeItem(expiredKey);
  if (isExpired) {
    storage.setItem(expiredKey, JSON.stringify({
      beginStamp: Date.now()
      // expireSec: expireSec
    }));
  }
}

/**
 * 
 *   判断是否为微信或者微信小程序
 * */
function isWXOrMiniprogram() {
  var ua = navigator.userAgent.toLowerCase();

  // 检查是否为微信浏览器
  var isWeChat = /micromessenger/.test(ua);

  // 判断是否为微信小程序
  var isMiniprogram = !/alipayclient/.test(ua) && /miniprogram/.test(ua) || isIos() && window.__wxjs_environment === "miniprogram";

  // 只要是微信或者微信小程序，都返回 true
  return isWeChat || isMiniprogram;
}

// 辅助函数：判断是否为 iOS 设备
function isIos() {
  return /iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase());
}

/**
 * [getStorageItem 从缓存获取数据，可传参expireSec判断是否处于效期内，配合setItem设置isExpired使用]
 * @param {Storage} storage [localStorage/sessionStorage]
 * @param {string} key
 * @param {number} expireSec [若需使用有效期内，设置>0的秒数]
 * 注：该key设置缓存时候没有设置有效期情况下，若设置expireSec，则表示已过有效期，将返回null
 *
 * @return {*} value [缓存返回的数据or过期数据or未命中null]
 */
function getStorageItem(storage, key, expireSec) {
  var item = storage.getItem(key),
    __expired__ = storage.getItem(key + "__expired__"),
    value;
  try {
    item = JSON.parse(item);
    if (typeof expireSec === "number" && expireSec > 0) {
      // 若需要判断是否过期
      __expired__ = JSON.parse(__expired__);
      if (__expired__ && __expired__.beginStamp) {
        // 有设置过期时间
        if (Date.now() <= __expired__.beginStamp + expireSec * 1000) {
          // 缓存未过期
          value = item;
        } else {
          // 缓存已过期
          value = null;
        }
      } else {
        // 没设置过期时间
        value = null;
      }
    } else {
      // 不需要判断是否过期
      value = item;
    }
  } catch (e) {
    // 若item不是对象字符串时候，JSON.parse失败，进入catch
    value = item || null;
  }
  return value;
}

// 设置localStorage数据
function setLocalStorageItem(key, value, isExpired) {
  setStorageItem(window.localStorage, key, value, isExpired);
}

// 从localStorage获取对象类型数据
function getLocalStorageItem(key, expireSec) {
  return getStorageItem(window.localStorage, key, expireSec);
}

// 设置sessionStorage数据
function setSessionStorageItem(key, value, isExpired) {
  // expireSec = typeof expireSec === "number" ? expireSec : null;
  setStorageItem(window.sessionStorage, key, value, isExpired);
}

// 从sessionStorage获取对象类型数据
function getSessionStorageItem(key, expireSec) {
  return getStorageItem(window.sessionStorage, key, expireSec);
}
var pi = 3.14159265358979324;
var a = 6378245.0;
var ee = 0.00669342162296594323;
var mapTools = {
  x_pi: 3.14159265358979324 * 3000.0 / 180.0,
  LLBAND: [75, 60, 45, 30, 15, 0],
  LL2MC: [[-0.0015702102444, 111320.7020616939, 1704480524535203, -10338987376042340, 26112667856603880, -35149669176653700, 26595700718403920, -10725012454188240, 1800819912950474, 82.5], [0.0008277824516172526, 111320.7020463578, 647795574.6671607, -4082003173.641316, 10774905663.51142, -15171875531.51559, 12053065338.62167, -5124939663.577472, 913311935.9512032, 67.5], [0.00337398766765, 111320.7020202162, 4481351.045890365, -23393751.19931662, 79682215.47186455, -115964993.2797253, 97236711.15602145, -43661946.33752821, 8477230.501135234, 52.5], [0.00220636496208, 111320.7020209128, 51751.86112841131, 3796837.749470245, 992013.7397791013, -1221952.21711287, 1340652.697009075, -620943.6990984312, 144416.9293806241, 37.5], [-0.0003441963504368392, 111320.7020576856, 278.2353980772752, 2485758.690035394, 6070.750963243378, 54821.18345352118, 9540.606633304236, -2710.55326746645, 1405.483844121726, 22.5], [-0.0003218135878613132, 111320.7020701615, 0.00369383431289, 823725.6402795718, 0.46104986909093, 2351.343141331292, 1.58060784298199, 8.77738589078284, 0.37238884252424, 7.45]],
  MCBAND: [12890594.86, 8362377.87, 5591021, 3481989.83, 1678043.12, 0],
  MC2LL: [[1.410526172116255e-8, 0.00000898305509648872, -1.9939833816331, 200.9824383106796, -187.2403703815547, 91.6087516669843, -23.38765649603339, 2.57121317296198, -0.03801003308653, 17337981.2], [-7.435856389565537e-9, 0.000008983055097726239, -0.78625201886289, 96.32687599759846, -1.85204757529826, -59.36935905485877, 47.40033549296737, -16.50741931063887, 2.28786674699375, 10260144.86], [-3.030883460898826e-8, 0.00000898305509983578, 0.30071316287616, 59.74293618442277, 7.357984074871, -25.38371002664745, 13.45380521110908, -3.29883767235584, 0.32710905363475, 6856817.37], [-1.981981304930552e-8, 0.000008983055099779535, 0.03278182852591, 40.31678527705744, 0.65659298677277, -4.44255534477492, 0.85341911805263, 0.12923347998204, -0.04625736007561, 4482777.06], [3.09191371068437e-9, 0.000008983055096812155, 0.00006995724062, 23.10934304144901, -0.00023663490511, -0.6321817810242, -0.00663494467273, 0.03430082397953, -0.00466043876332, 2555164.4], [2.890871144776878e-9, 0.000008983055095805407, -3.068298e-8, 7.47137025468032, -0.00000353937994, -0.02145144861037, -0.00001234426596, 0.00010322952773, -0.00000323890364, 826088.5]],
  getRange: function getRange(cC, cB, T) {
    if (cB != null) {
      cC = Math.max(cC, cB);
    }
    if (T != null) {
      cC = Math.min(cC, T);
    }
    return cC;
  },
  getLoop: function getLoop(cC, cB, T) {
    while (cC > T) {
      cC -= T - cB;
    }
    while (cC < cB) {
      cC += T - cB;
    }
    return cC;
  },
  convertor: function convertor(cC, cD) {
    if (!cC || !cD) {
      return null;
    }
    var T = cD[0] + cD[1] * Math.abs(cC.x);
    var cB = Math.abs(cC.y) / cD[9];
    var cE = cD[2] + cD[3] * cB + cD[4] * cB * cB + cD[5] * cB * cB * cB + cD[6] * cB * cB * cB * cB + cD[7] * cB * cB * cB * cB * cB + cD[8] * cB * cB * cB * cB * cB * cB;
    T *= cC.x < 0 ? -1 : 1;
    cE *= cC.y < 0 ? -1 : 1;
    return [T, cE];
  },
  /**
   * 百度墨卡托坐标转百度经纬度坐标：
   * @param {*} cB
   * @returns
   */
  convertBdMC2LL: function convertBdMC2LL(lnglat) {
    var cB = {
      x: lnglat.lng,
      y: lnglat.lat
    };
    var cC = {
      x: Math.abs(cB.x),
      y: Math.abs(cB.y)
    };
    var cE;
    for (var cD = 0, len = this.MCBAND.length; cD < len; cD++) {
      if (cC.y >= this.MCBAND[cD]) {
        cE = this.MC2LL[cD];
        break;
      }
    }
    var T = this.convertor(cB, cE);
    return T;
  },
  /**
   * 百度BD09经纬度坐标转百度墨卡托坐标：
   * @param {*} T
   * @returns
   */
  convertBdLL2MC: function convertBdLL2MC(lnglat) {
    var T = {
      x: lnglat.lng,
      y: lnglat.lat
    };
    var cD, cC, len;
    T.x = this.getLoop(T.x, -180, 180);
    T.y = this.getRange(T.y, -74, 74);
    var cB = T;
    for (cC = 0, len = this.LLBAND.length; cC < len; cC++) {
      if (cB.y >= this.LLBAND[cC]) {
        cD = this.LL2MC[cC];
        break;
      }
    }
    if (!cD) {
      for (cC = this.LLBAND.length - 1; cC >= 0; cC--) {
        if (cB.y <= -this.LLBAND[cC]) {
          cD = this.LL2MC[cC];
          break;
        }
      }
    }
    var cE = this.convertor(T, cD);
    // return cE;
    return {
      lng: cE[0],
      lat: cE[1]
    };
  },
  /*判断是否在国内，不在国内则不做偏移*/
  outOfChina: function outOfChina(lon, lat) {
    if ((lon < 72.004 || lon > 137.8347) && (lat < 0.8293 || lat > 55.8271)) {
      return true;
    } else {
      return false;
    }
  },
  transformLat: function transformLat(x, y) {
    var ret = -100.0 + 2.0 * x + 3.0 * y + 0.2 * y * y + 0.1 * x * y + 0.2 * Math.sqrt(Math.abs(x));
    ret += (20.0 * Math.sin(6.0 * x * pi) + 20.0 * Math.sin(2.0 * x * pi)) * 2.0 / 3.0;
    ret += (20.0 * Math.sin(y * pi) + 40.0 * Math.sin(y / 3.0 * pi)) * 2.0 / 3.0;
    ret += (160.0 * Math.sin(y / 12.0 * pi) + 320 * Math.sin(y * pi / 30.0)) * 2.0 / 3.0;
    return ret;
  },
  transformLon: function transformLon(x, y) {
    var ret = 300.0 + x + 2.0 * y + 0.1 * x * x + 0.1 * x * y + 0.1 * Math.sqrt(Math.abs(x));
    ret += (20.0 * Math.sin(6.0 * x * pi) + 20.0 * Math.sin(2.0 * x * pi)) * 2.0 / 3.0;
    ret += (20.0 * Math.sin(x * pi) + 40.0 * Math.sin(x / 3.0 * pi)) * 2.0 / 3.0;
    ret += (150.0 * Math.sin(x / 12.0 * pi) + 300.0 * Math.sin(x / 30.0 * pi)) * 2.0 / 3.0;
    return ret;
  },
  delta: function delta(lat, lon) {
    var a = 6378245.0; //  a: 卫星椭球坐标投影到平面地图坐标系的投影因子。
    var ee = 0.00669342162296594323; //  ee: 椭球的偏心率。
    var dLat = this.transformLat(lon - 105.0, lat - 35.0);
    var dLon = this.transformLon(lon - 105.0, lat - 35.0);
    var radLat = lat / 180.0 * pi;
    var magic = Math.sin(radLat);
    magic = 1 - ee * magic * magic;
    var sqrtMagic = Math.sqrt(magic);
    dLat = dLat * 180.0 / (a * (1 - ee) / (magic * sqrtMagic) * pi);
    dLon = dLon * 180.0 / (a / sqrtMagic * Math.cos(radLat) * pi);
    return {
      lat: dLat,
      lon: dLon
    };
  },
  // 地球坐标系(WGS-84)转火星坐标系(GCJ)：
  transformWGS2GCJ: function transformWGS2GCJ(lnglat) {
    var wgLat = lnglat.lat;
    var wgLon = lnglat.lng;
    var mars_point = {};
    if (this.outOfChina(wgLon, wgLat)) {
      mars_point.lat = wgLat;
      mars_point.lon = wgLon;
      return;
    }
    var dLat = this.transformLat(wgLon - 105.0, wgLat - 35.0);
    var dLon = this.transformLon(wgLon - 105.0, wgLat - 35.0);
    var radLat = wgLat / 180.0 * pi;
    var magic = Math.sin(radLat);
    magic = 1 - ee * magic * magic;
    var sqrtMagic = Math.sqrt(magic);
    dLat = dLat * 180.0 / (a * (1 - ee) / (magic * sqrtMagic) * pi);
    dLon = dLon * 180.0 / (a / sqrtMagic * Math.cos(radLat) * pi);
    mars_point.lat = wgLat + dLat;
    mars_point.lng = wgLon + dLon;
    return mars_point;
  },
  // 火星坐标系GCJ02转地球坐标系WGS84：
  transformGCJ2WGS: function transformGCJ2WGS(lnglat) {
    var gcjLat = lnglat.lat;
    var gcjLon = lnglat.lng;
    var d = this.delta(gcjLat, gcjLon);
    return {
      lat: gcjLat - d.lat,
      lng: gcjLon - d.lon
    };
  },
  /**
   * 百度坐标转火星坐标：
   * @param {*} baidu_point
   * @returns
   */
  baiduTomars: function baiduTomars(baidu_point) {
    var mars_point = {
      lng: 0,
      lat: 0
    };
    var x = baidu_point.lng - 0.0065;
    var y = baidu_point.lat - 0.006;
    var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * this.x_pi);
    var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * this.x_pi);
    mars_point.lng = z * Math.cos(theta);
    mars_point.lat = z * Math.sin(theta);
    return mars_point;
  },
  /**
   * 火星坐标转百度坐标：
   * @param {*} mars_point
   * @returns
   */
  marsTobaidu: function marsTobaidu(mars_point) {
    var baidu_point = {
      lng: 0,
      lat: 0
    };
    var x = mars_point.lng;
    var y = mars_point.lat;
    var z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * this.x_pi);
    var theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * this.x_pi);
    baidu_point.lng = z * Math.cos(theta) + 0.0065;
    baidu_point.lat = z * Math.sin(theta) + 0.006;
    return baidu_point;
  },
  /**
   * 百度转WGS84
   */
  baiduToWGS: function baiduToWGS(baidu_point) {
    //先转为火星坐标
    var mars_point = this.baiduTomars(baidu_point);
    //再转为wgs
    return this.transformGCJ2WGS(mars_point);
  },
  /**
   * WGS84转为百度
   */
  WGSTobaidu: function WGSTobaidu(point) {
    //先转为火星坐标
    var mars_point = this.transformWGS2GCJ(point);
    //再转为百度
    return this.marsTobaidu(mars_point);
  }
};

/////////////////////////////////////////////////////////////////////////////////
//
/////////////////////////////////////////////////////////////////////////////////

var CACHE_KEY = "KEY_CACHE_YCF_LOC_INFO";
var CACHE_EXPIRY_SEC = 14 * 24 * 60 * 60; // 14 天的秒数

export function ex_getYCFLocInfo() {
  console.success("======滚蛋吧!百度 in ex_getYCFLocInfo ====");

  //const is_mock = true
  var is_mock = false;
  var _getYCFLocInfoImpl = function _getYCFLocInfoImpl(lat, lng, resolve, reject) {
    var url = "https://api.yunkezan.com/appapi/public/getaddress?lat=" + lat + "&long=" + lng;
    console.success("====== _getYCFLocInfoImpl begin=====");
    console.success(url);
    $.ajax({
      //type: "GET", 
      //dataType: "jsonp", 
      url: url,
      success: function success(res) {
        console.success("======_getYCFLocInfoImpl has response!=======");
        console.success(res);
        if (res.code == 1000 && res.bcode == 100) {
          console.success("======_getYCFLocInfoImpl success translate to bdpoint !=======");
          var content = res.content;
          var point = {
            'lat': parseFloat(lat),
            'lng': parseFloat(lng)
          };
          console.success("in point");
          console.success(point);
          var bdPoint = mapTools.WGSTobaidu(point);
          console.success(bdPoint, '====== 经过转换后的经纬度 ======');
          content.latitude = bdPoint.lat;
          content.longitude = bdPoint.lng;
          content.authorization = true;
          setLocalStorageItem(CACHE_KEY, content, true);
          resolve(content);
        } else {
          console.success("======_getYCFLocInfoImpl error=======");
          _useCacheLocInfo(resolve);
        }
      },
      error: function error(err) {
        console.success("=======_getYCFLocInfoImpl suck========");
        console.success(err);
        _useCacheLocInfo(resolve);
      },
      complete: function complete() {}
    });
  };
  var _useCacheLocInfo = function _useCacheLocInfo(resolve) {
    var storageData = getLocalStorageItem(CACHE_KEY, CACHE_EXPIRY_SEC);
    if (storageData) {
      console.success("======_useCacheLocInfo success=======");
      resolve(storageData);
    } else {
      console.success("======_useCacheLocInfo suck=======");
      _useDefaultLocInfo(resolve);
    }
  };
  var _useDefaultLocInfo = function _useDefaultLocInfo(resolve) {
    console.success("======_useDefaultLocInfo =======");
    resolve({
      province: "广东省",
      city: "广州市",
      district: "天河区",
      addrStr: "科韵路20号",
      street: "数码港大厦",
      cityCode: "440100",
      districtCode: "440106",
      latitude: "23.13",
      longitude: "113.27"
    });
  };
  return new Promise(function (resolve, reject) {
    if (is_mock) {
      var lat = "39.92594";
      var lng = "116.37304";
      _getYCFLocInfoImpl(lat, lng, resolve, reject);
    }
    // else if (isWXOrMiniprogram()) {
    //     // 微信环境下 使用微信自带的定位
    //     wx.ready(() => {
    //         wx.getLocation({
    //             type: 'gcj02',
    //             success: (res) => {
    //                 console.success("======= wx.getLocation success! =======", res);
    //                 const { latitude, longitude } = res;
    //                 _getYCFLocInfoImpl(latitude, longitude, resolve, reject);
    //             },
    //             fail: (error) => {
    //                 console.success("======= wx.getLocation error! =======");
    //                 _useCacheLocInfo(resolve)
    //             }
    //         });
    //     });
    // }
    else {
      var storageData = getLocalStorageItem(CACHE_KEY, CACHE_EXPIRY_SEC);
      if (storageData) {
        console.log(storageData, 'storageDatastorageData');
        // 如果缓存数据在14天内有效，直接使用缓存
        console.success("====== 缓存数据有效，直接返回缓存 ======");
        storageData.authorization = false;
        resolve(storageData);
      } else {
        // 配置不需获取定位的URL
        var disabledUrl = ["/front/index/privacyPolicy"];
        if (sessionStorage.getItem("session_isShop")) {
          // 支付宝支付结果页不会显示大家都去 直接禁用
          disabledUrl.push('/front/promoter/promoterSearchResult');
        }
        if (navigator.geolocation && !disabledUrl.includes(location.pathname)) {
          console.log('=======浏览器定位开始！========');
          var isTimeout = false;
          setTimeout(function () {
            console.log('=======浏览器定位超时！========');
            isTimeout = true;
            _useCacheLocInfo(resolve);
          }, 7000);
          navigator.geolocation.getCurrentPosition(function (position) {
            if (isTimeout) {
              return;
            }
            console.success(position.coords.latitude, position.coords.longitude, '<---geolocation--当前经纬度');
            //alert('经度：'+ position.coords.latitude+",纬度："+ position.coords.longitude)
            _getYCFLocInfoImpl(position.coords.latitude, position.coords.longitude, resolve, reject);
          }, function (error) {
            if (isTimeout) {
              return;
            }
            console.log(error);
            switch (error.code) {
              case error.PERMISSION_DENIED:
                //alert('用户拒绝对获取地理位置的请求。')
                break;
              case error.POSITION_UNAVAILABLE:
                //alert('当前位置信息不可用。')
                break;
              case error.TIMEOUT:
                //alert('请求用户地理位置超时。')
                break;
              case error.UNKNOWN_ERROR:
                //alert('未知错误。')
                break;
            }
            _useCacheLocInfo(resolve);
          }, {
            enableHighAcuracy: false
          });
        } else {
          console.log('===========当前浏览器不支持获取定位！==============');
          //alert('当前浏览器不支持获取定位！')
          _useCacheLocInfo(resolve);
        }
      }
    }
  });
}